import "./TouristVisasConsularVisas.module.css";
import Header from "@/reusable_sections/Header";
import PatioDoorRepairServicesInSaintLambert from "./sections/PatioDoorRepairServicesInSaintLambert";
import ServicesGrid from "./sections/ServicesGrid";
import CountryVisaDirectory from "./sections/CountryVisaDirectory";
import Footer from "@/reusable_sections/Footer";
export default function TouristVisasConsularVisasPage() {
  return <div>
      <Header />
      <PatioDoorRepairServicesInSaintLambert />
      <ServicesGrid />
      <CountryVisaDirectory />
      <Footer />
    </div>;
}